import { Button, ButtonProps, SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import { AddCircleOutline } from '@material-ui/icons';
import theme from 'theme';

const useStyles = makeStyles({
  createButton: {
    textTransform: 'none',
    fontSize: 12,
    fontWeight: 600,
  },
  createButtonEnabled: {
    color: theme.palette.primary.main,
  },
  createButtonDisabled: {
    color: theme.palette.grey[600],
  },
  actionIcon: {
    width: 39,
    height: 39,
  },
});

type ActionButtonProps<C extends React.ElementType> = ButtonProps<C, { component?: C }> & {
  icon: React.ElementType | null;
  label: string | null;
  customClasses?: string;
  customClassesIcon?: string;
};

const CreateButton = <C extends React.ElementType>({
  icon,
  label,
  disabled,
  customClasses,
  customClassesIcon,
  ...props
}: ActionButtonProps<C>) => {
  const classes = useStyles();
  const myIcon = icon ?? AddCircleOutline;

  return (
    <Button
      {...props}
      className={classNames(customClasses, classes.createButton, {
        [classes.createButtonEnabled]: !disabled,
        [classes.createButtonDisabled]: disabled,
      })}
      disabled={disabled}
    >
      <SvgIcon component={myIcon} className={classNames(classes.actionIcon, customClassesIcon)} />
      {label}
    </Button>
  );
};

export default CreateButton;
